import { render, staticRenderFns } from "./DocumentsUpload.vue?vue&type=template&id=e2e2c8e8&scoped=true&"
import script from "./DocumentsUpload.vue?vue&type=script&lang=ts&"
export * from "./DocumentsUpload.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentsUpload.vue?vue&type=style&index=0&id=e2e2c8e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e2c8e8",
  null
  
)

export default component.exports